export default __webpack_public_path__ + "static/media/features.ebda3785.jpg";